// Public-page tab cache cleanup
// tabs.js resets "#myTab .nav-link" before Turbo caches a page so the
// snapshot doesn't restore a stale active tab. Public city pages use
// ".public-dept-tab" instead of ".nav-link", so they need their own cleanup.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("#myTab .public-dept-tab").forEach((el) => {
    el.classList.remove("active");
  });
});
